import React from "react";
import { Link } from "react-router-dom";
import { appNavigation } from "../../utils";

const legalLinks = [
  { href: 'https://storyclub.ai/terms-of-service/', label: 'Terms of Service' },
  { href: 'https://storyclub.ai/privacy-policy/', label: 'Privacy Policy' },
  { href: 'https://storyclub.ai/cookie-policy/', label: 'Cookie Policy' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer" role="contentinfo" aria-label="Footer">
      <div className="footer-inner">
        <div className="footer-left">
          <span className="footer-brand"><a href="https://storyclub.ai">Storyclub.ai</a></span>
          <span className="footer-dot" aria-hidden>•</span>
          <span className="footer-copy">© {year}</span>
        </div>

        <nav className="footer-legal" aria-label="Legal links">
          <Link to={appNavigation.subscribe}>Subscribe</Link>
          {legalLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <nav className="footer-right" aria-label="Social media">
          {/* X / Twitter */}
         <a
          className="footer-icon"
          href="https://x.com/storyclubai"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X (Twitter)"
          title="X (Twitter)"
        >
          <svg
            viewBox="0 0 24 24"
            width="24" height="24"
            aria-hidden="true" focusable="false"
            className="footer-icon-svg"
            shapeRendering="geometricPrecision"
          >
            <path
              d="M4 4L20 20M20 4L4 20"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        </a>

          {/* YouTube */}
          <a
            className="footer-icon"
            href="https://www.youtube.com/channel/UCkYUTNi2pzZZLVIEpaqURLg"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
            title="YouTube"
          >
            <svg
              viewBox="0 0 24 24"
              width="24" height="24"
              aria-hidden="true" focusable="false"
              className="footer-icon-svg"
              shapeRendering="geometricPrecision"
            >
              <path
                fill="currentColor"
                d="M23.5 6.2a3.1 3.1 0 0 0-2.17-2.2C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.33.5A3.1 3.1 0 0 0 .5 6.2 32 32 0 0 0 0 12a32 32 0 0 0 .5 5.8 3.1 3.1 0 0 0 2.17 2.2C4.5 20.5 12 20.5 12 20.5s7.5 0 9.33-.5a3.1 3.1 0 0 0 2.17-2.2 32 32 0 0 0 .5-5.8 32 32 0 0 0-.5-5.8ZM9.75 15.02V8.98L15.5 12l-5.75 3.02Z"
              />
            </svg>
          </a>

          {/* Instagram */}          
          <a
            className="footer-icon"
            href="https://www.instagram.com/storyclub.ai/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            title="Instagram"
          >
            <svg
              viewBox="0 0 24 24"
              width="24" height="24"
              aria-hidden="true" focusable="false"
              className="footer-icon-svg"
              shapeRendering="geometricPrecision"
            >
              <rect
                x="3" y="3" width="18" height="18" rx="5" ry="5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              />
              <circle
                cx="12" cy="12" r="4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              />
              <circle cx="17" cy="7" r="1.2" fill="currentColor" />
            </svg>
          </a>

          {/* Facebook */}
          <a
            className="footer-icon"
            href="https://www.facebook.com/frekiai"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            title="Facebook"
          >
            <svg
              viewBox="0 0 24 24"
              width="24" height="24"
              aria-hidden="true" focusable="false"
              className="footer-icon-svg"
              shapeRendering="geometricPrecision"
            >
              <path
                fill="currentColor"
                d="M22 12a10 10 0 1 0-11.56 9.9v-7h-2.3V12h2.3V9.8c0-2.27 1.35-3.53 3.42-3.53.99 0 2.02.18 2.02.18v2.22h-1.14c-1.12 0-1.47.69-1.47 1.4V12h2.5l-.4 2.9h-2.1v7A10 10 0 0 0 22 12Z"
              />
            </svg>
          </a>
        </nav>
      </div>
    </footer>
  );
}
